module.exports = __webpack_public_path__ + "static/img/banner_title.cda11e5c.png";